"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipStyled = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      borderRadius: '0.938rem',
      fontSize: '0.75rem',
      maxWidth: '100%',
      padding: '1.313rem 1.5rem',
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.secondary.main,
      marginTop: "0.4375rem"
    },
    arrow: {
      color: theme.palette.secondary.dark,
      display: "none"
    }
  };
})(_Tooltip.default);
var _default = TooltipStyled;
exports.default = _default;